var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.735 12.8493C6.55446 12.6573 6.30541 12.5443 6.04201 12.535C5.77861 12.5256 5.52217 12.6206 5.32844 12.7993C5.13471 12.978 5.01937 13.226 5.00749 13.4893C4.99561 13.7526 5.08815 14.0099 5.265 14.2053L8.877 18.1243C9.414 18.6503 10.214 18.6503 10.711 18.1543L11.075 17.7953C12.3895 16.5026 13.7025 15.2082 15.014 13.9123L15.054 13.8723C16.2797 12.6644 17.499 11.45 18.712 10.2293C18.8933 10.0395 18.9927 9.78606 18.9887 9.52363C18.9848 9.26119 18.8778 9.01082 18.6909 8.82655C18.504 8.64227 18.2522 8.53886 17.9897 8.53864C17.7273 8.53841 17.4752 8.64138 17.288 8.82533C16.0807 10.0397 14.8673 11.248 13.648 12.4503L13.608 12.4903C12.3513 13.7326 11.0929 14.9733 9.833 16.2123L6.735 12.8493Z",
    fill: "#36B37E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCheck);
export default __webpack_public_path__ + "static/media/form-check.49b44050.svg";
export { ForwardRef as ReactComponent };